import {
  Box,
  Checkbox,
  CircularProgress,
  Typography,
  Button,
  Alert,
} from "@mui/material";
import { SMSConsentModal } from "../../../pages/contractors/contractor-signup/ContractorSignupForms/SMSConsentModal";
import { useState } from "react";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import theme from "../../../theme";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  acceptContractorConsentAction,
  alertDialogAciton,
  logoutAction,
} from "../../../store/actions/auth";
import { useSelector } from "react-redux";
import { isUserRole, isActiveRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";
import { useFormik } from "formik";
import * as Yup from "yup";
import { phoneNumberFormat } from "../../../appCalcutions";
import { CustomInput } from "../../Custom/Input";
import { alpha, fontSize } from "@mui/system";
import { WEB_CONTRACTOR_CONSENT } from "../../../utils/constants/urls";

// NOTE: style for modal
const style = {
  m: "auto",
  width: 400,
  boxShadow: 24,
  p: 4,
  minWidth: "700px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  "@media (max-width: 600px)": {
    minWidth: "96vw",
    maxHeight: "96vh",
    width: "97vw",
    overflowY: "auto",
  },
};

export const ContractorConsent = () => {
  const [smsConsent, setSmsConsent] = useState(false);
  const [agreedToSMS, setAgreedToSMS] = useState(false);
  const [agreedToTandC, setAgreedToTandC] = useState(false);
  const {
    loading,
    phoneNumber: mobile,
    userId,
    contractorType,
  } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function logoutFunction() {
    dispatch(logoutAction({}));
    navigate("/login");
  }

  async function submitHandler() {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0 && !mobile) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Alert",
          message: "Please enter your mobile number before submitting.",
        }),
      );
      return;
    }
    if (!agreedToTandC || !agreedToSMS) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Alert",
          message:
            "Please agree to terms and conditions, privacy policy and SMS consent to continue.",
        }),
      );
      return;
    } else {
      // api to accept contractor consent
      dispatch(
        acceptContractorConsentAction({
          payload: {
            params: {
              userId,
            },
            data: {
              termsAcceptedAt: true,
              smsPermissionStatus: true,
              ...(!mobile
                ? {
                    mobile: formik?.values?.mobile,
                  }
                : {}),
            },
          },
        }),
      );
    }
  }

  const linkSX = {
    all: "unset",
    cursor: "pointer",
    color: theme.palette.green.main,
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "underline",
    },
    "&:active": {
      filter: "brightness(0.85)",
    },
    "&:visited": {
      color: theme.palette.green.main,
    },
    "&::-webkit-any-link": {
      color: theme.palette.green.main,
    },
  };

  const initialValues = {
    mobile: "",
  };

  const validationSchema = Yup.object().shape({
    mobile: Yup.string()
      .matches(/^\d{3}-\d{3}-\d{4}$/, "Mobile number must be of 10 digit")
      .required("Mobile number required"),
  });

  // only use for validation
  const formik = useFormik({
    initialValues,
    validationSchema,
  });

  const handleMobileChange = (event) => {
    const input = event.target.value;
    const formattedInput = input
      .replace(/\D/g, "")
      .replace(/(\d{1,3})(\d{1,3})?(\d{1,4})?/, function (_, p1, p2, p3) {
        let formattedNumber = "";
        if (p1) {
          formattedNumber += p1;
        }
        if (p2) {
          formattedNumber += "-" + p2;
        }
        if (p3) {
          formattedNumber += "-" + p3;
        }
        return formattedNumber;
      });
    formik.setFieldValue("mobile", formattedInput);
  };

  return (
    <Box
      sx={{
        ...style,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        {/* <Typography fontSize={"1.5rem"} fontWeight={500}>
          Contractor Consent Terms
        </Typography> */}
        <Typography fontSize="1.5rem" fontWeight={500}>
          {isActiveRole(USER_ROLES.CLIENT)
            ? "Client Consent Terms"
            : isActiveRole(USER_ROLES.FREELANCE_EC)
              ? "Freelance EC Consent Terms"
              : "Contractor Consent Terms"}
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            flexDirection: "column",
            gap: "0.75rem",
          }}
        >
          {!mobile ? (
            <Box
              sx={{
                // ml: "2rem",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "1rem",
                flexDirection: "column",
                // border: "1px solid",
                // borderColor: getCssVariableHandler({
                //   variableName: "--primary-pink-hex",
                // }),
                // borderRadius: "0.5rem",
                padding: "0.5rem 0.75rem",
              }}
            >
              <Alert
                severity="warning"
                sx={{
                  py: "0",
                  px: 1,
                  textAlign: "center",
                  backgroundColor: alpha("#ff9800", 0.2),
                  color: "#ffa726",
                  "& .MuiAlert-icon": {
                    color: "#ffa726",
                  },
                }}
              >
                Your account is missing a required Mobile number.
              </Alert>
              <Typography
                sx={{
                  // ml: "2rem",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "0.5rem",
                  // alignSelf: "flex-start",
                }}
              >
                <Typography fontWeight={500}>Mobile Number:</Typography>
                <CustomInput
                  value={formik?.values?.mobile}
                  onChange={(e) => handleMobileChange(e)}
                  className="applied-rate"
                  sx={{
                    width: "10rem !important",
                    fontSize: "1rem !important",
                    "& input": {
                      paddingTop: "1px",
                      paddingBottom: "1px",
                      paddingX: "0.5rem",
                    },
                    borderColor: "white",
                  }}
                />
              </Typography>
              {formik?.errors?.mobile && (
                <Typography color="red">{formik?.errors?.mobile}</Typography>
              )}
            </Box>
          ) : null}

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "centere",
              gap: "0.25rem",
            }}
          >
            <Checkbox
              onChange={(e) => {
                setAgreedToTandC(e.target.checked);
              }}
              sx={{
                color: getCssVariableHandler({
                  variableName: "--font-rgb",
                }),
                padding: "0",
              }}
              checked={agreedToTandC}
            />

            <Typography>
              I accept the{" "}
              <NavLink
                style={linkSX}
                to={"/terms-and-conditions"}
                target="_blank"
              >
                Terms and Conditions
              </NavLink>{" "}
              and{" "}
              <NavLink style={linkSX} to={"/privacy-policy"} target="_blank">
                Privacy policy
              </NavLink>
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "0.25rem",
            }}
          >
            <Checkbox
              onChange={(e) => {
                setAgreedToSMS(e.target.checked);
              }}
              sx={{
                color: getCssVariableHandler({
                  variableName: "--font-rgb",
                }),
                padding: "0",
              }}
              checked={agreedToSMS}
            />

            <Typography>
              I agree to receive SMS updates from ShowPhaze about my account,
              event schedule, and important service messages. Message and data
              rates may apply. I understand I can opt out anytime by replying
              STOP. View full{" "}
              <Typography
                sx={{
                  cursor: "pointer",
                  color: theme.palette.green.main,
                  display: "inline-flex",
                  textDecoration: "underline",
                  "&:active": {
                    opacity: "0.8",
                  },
                }}
                onClick={() => setSmsConsent(true)}
              >
                SMS terms
              </Typography>
              .
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          "& button": {
            cursor: "pointer",
          },
        }}
        className="bottom-btn-box"
      >
        <Button className="btn-black" onClick={logoutFunction}>
          <Typography className="btn-text">Logout</Typography>
        </Button>
        <Button
          className="btn-pink"
          onClick={() => {
            submitHandler();
          }}
        >
          {loading ? (
            <CircularProgress size={22} />
          ) : (
            <Typography className="btn-text">Submit</Typography>
          )}
        </Button>
      </Box>

      <SMSConsentModal
        open={smsConsent}
        handleClose={() => setSmsConsent(false)}
      />
    </Box>
  );
};
